<form *ngIf="allClients$ | async as allClients; else loadingClients">
  <mat-form-field class="client-chip-list">
    <mat-label>Clients</mat-label>
    <mat-select multiple [formControl]="selectedClientsControl">
      <mat-select-trigger>
        @if (!selectedClientsControl.value) {
          Select Clients
        } @else if (isAllClientsSelected(selectedClientsControl.value)) { 
          {{ ALL_CLIENTS_SELECTED.memberName }} 
        } @else {
          @for (client of selectedClientsControl.value; track client.memberId; let isLast = $last) {
            {{ client.memberName }}@if(!isLast) {, }
          }
        }
      </mat-select-trigger>
      <mat-option 
          [value]="ALL_CLIENTS_SELECTED" 
          (click)="toggleAllClients(selectedClientsControl, allClients)">
        Select All
      </mat-option>
      @for(client of allClients; track client.memberId) {
        <mat-option 
            [value]="client" 
            (click)="toggleClient(selectedClientsControl, allClients, client)">
          {{getMemberDisplayName(client)}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>

<ng-template #loadingClients>
  <div class="loading-clients">
    Clients with Spend Loading...
  </div>
</ng-template>
